export default {"src":"/_next/static/media/appc.c55beb60.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};